import React from 'react';
import { ReactComponent as DownloadIcon } from "../../../../assets/img/svg/fi_download.svg";
import { ReactComponent as PdfIcon } from "../../../../assets/img/svg/pdfIcon.svg"
import { downLoadFile } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/common';
import styles from "../style.module.scss";
import { formattedPrice } from 'views/pages/manage/unAssigned/collectPayment/utils';
import { CourseDetailsPopupById } from 'views/pages/manage/unAssigned/studentCharges/common';
import { IoEyeOutline } from "react-icons/io5"
import { Tooltip } from '@mui/material';
import { COMPLETION_REFUND, MULTI_TYPE_REFUND } from '../../studentRefundRequest/config';
export const studentDetails = (orderType) => [
  { key: "psid", label: "PSID" },
  { key: "studentName", label: "Student Name" },
  { key: "applicationId", label: "Application No." },
  { key: "studentFatherName", label: "Parent name" },
  { key: "regularCourseId", label: "Regular Course ID", extraComponent: ({ value, dropdownData }) => value ? <div className='d-flex' style={{ gap: '6px' }}>{value}<CourseDetailsPopupById courseId={value} placement="left-end" cta={<IoEyeOutline className='ml-2' />} /></div> : '-' },
  { key: "sdCourseId", label: "SD Course ID", extraComponent: ({ value }) => value ? <div className='d-flex' style={{ gap: '6px' }}>{value}<CourseDetailsPopupById courseId={value} placement="left-end" cta={<IoEyeOutline className='ml-2' />} /></div> : '-' },
  { key: "termValue", label: "Term" },
  { key: "career", label: "Career" },//--
  { key: "stream", label: "Stream" },//--
  ...(orderType !== COMPLETION_REFUND ? [{
    key: "refundAmount",
    label: "Refund Amount",
    extraComponent: ({ value }) => <div
      className={`${styles['amount']}`}>
      {
        formattedPrice(value)
      }
    </div>
  }] : []),
  {
    key: "businessAreaValue", label: "BU", extraComponent: ({ value, dropdownData }) => {
      const buDesc = dropdownData?.businessAreas?.find(bu => bu?.businessAreaDispValue === value)?.businessAreaDesc;
      return value ? <div className='d-flex' style={{ gap: '6px' }}>{value}<Tooltip title={buDesc}>
        <span className='ml-2'><IoEyeOutline /></span>
      </Tooltip></div> : '-'

    }
  },//--
  {
    key: "cashierOffice", label: "Cashier's office", extraComponent: ({ value, dropdownData }) => {
      const buDesc = dropdownData?.businessAreas?.find(bu => bu?.businessAreaDispValue === value)?.businessAreaDesc;
      return value ? <div className='d-flex' style={{ gap: '6px' }}>{value}<Tooltip title={buDesc}>
        <span className='ml-2'><IoEyeOutline /></span>
      </Tooltip></div> : '-'

    }
  },//--
  { key: "batch", label: "Batch" },//--
];


export const refundDetail = [
  { key: "refundNumber", label: "Request Tracking No." },
  { key: "orderType", label: "Refund Type" },
  {
    key: "refundAmount", label: "Refund Amount",
    extraComponent: ({ value }) => <div
      className={`${styles['amount']}`}>
      {
        formattedPrice(value)
      }
    </div>
  },
  { key: "paymentModeType", label: "Paymode" },
  { key: "bankKey", label: "Bank" },
  { key: "paymentModeNumber", label: "Account number" },
  { key: "accountType", label: "Account Type" },
  { key: "ifscCode", label: "IFSC Code" },
  { key: "beneficiaryName", label: "Name on account" },
  { key: "paymentModeDate", label: "Cheque Date" },
  { key: "supportingDocument", label: "Attachment" },
];


export const statusStyle = {
  Rejected: {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Failed: {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  "Auto-Rejected": {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Approved: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Completed: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Success: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Pending: {
    backgroundColor: "#FFEDC8",
    color: "#705010",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Recheck: {
    backgroundColor: "#FFEDC8",
    color: "#705010",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  "Sent back for correction": {
    backgroundColor: "#F5F5F5",
    textColor: "#262626",          // dark navy text
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  }
};

export const statusMapping = {
  COMPLETED: "Completed",
  PENDING: "Pending",
  REJECTED: "Rejected",
  INITIATED: "Initiated",
  APPROVED: "Approved",
  IN_PROCESS: "Pending",
  SUCCESS: "Success",
  FAILED: 'Failed',
  USER_RECHECK: 'Recheck',
  ACTION_NEEDED: 'Sent back for correction',
};

export const getProgressStepList = (approvalLevelCount = 0, orderType, uniqueReceiptTitles) => {

  // Build initial + approval steps as objects
  const initialSteps = [{ title: 'Refund Initiated' }];
  const approvalSteps = orderType === 'INTERNAL_REFUND' ? [] : Array.from({ length: approvalLevelCount }, (_, i) => ({ title: `L${i + 1} Approval` }));

  const receiptGenerationSubSteps = Array.from({ length: uniqueReceiptTitles.length }, (_, i) => ({ title: uniqueReceiptTitles[i] }));

  const sapSyncStep = {
    title: 'SAP Sync',
    subSteps: orderType == 'COMPLETION_REFUND' ? [// in comoletion refunf only refund to parent
      {
        title: 'Refunded to parent', isRemarkNeeded: true, extraComponent: () => {
          return <></>
        }
      },
    ] : [// in multi type refund both steps
      {
        title: 'Refunded to parent', isRemarkNeeded: true, extraComponent: () => {
          return <></>
        }
      },
      { title: 'Refunded to loan partner', isRemarkNeeded: true }
    ],
  };
  const receiptGenerationStep = {
    title: 'Receipt Generation',
    subSteps: receiptGenerationSubSteps,
  };
  let midStep = [];
  if (orderType !== 'RECTIFICATION_REFUND' && orderType !== 'INTERNAL_REFUND') {
    midStep.push(sapSyncStep)
  }
  // if (orderType && orderType != 'COMPLETION_REFUND')// removing this condition as all type of refunds can have receipt generation
  midStep.push(receiptGenerationStep)

  const finalStep = { title: 'Refund Processed' };

  return [...initialSteps, ...approvalSteps, ...midStep, finalStep];
};


// export const generatingProgressStepList = (progressStepList = [], logs = []) => {
//   debugger
//   if (logs.length === 0) return [];

//   const stopAt = logs[0].title;
//   const tempStepList = [];

//   for (let step of progressStepList) {
//     tempStepList.push(step);
//     if (step === stopAt) break;
//   }

//   return tempStepList;
// };

// Create a default upcoming step


export const NOTIFY_CHANNELS = [
  { label: "Email", name: "email" },
  { label: "SMS", name: "sms" },
  { label: "Whatsapp", name: "whatsapp" },
];



export const displayFile = (value) => {
  if (value.length) {
    return <div className='d-flex align-items-center'> <PdfIcon height={22} /> {value.map((item, index) => (
      <div className="d-flex">
        <span>
          Attachment{index + 1}
        </span>
        <span className='cursor' onClick={() => downLoadFile(true, item?.s3Key ?? item)}>
          <DownloadIcon />
        </span>
      </div>
    ))}
    </div>
  } else
    return "-"
}


export const updateRectificationReceiptEntryLogs = (logs = []) => {
  const receiptCourseMap = new Map();
  const orderedUniqueTitles = []; //preserve global chronological order

  const updatedLogList = logs.map((log) => {
    let title;
    const { action = "", status = "", remark = "" } = log;

    const isReceiptEntry = action?.toLowerCase().includes("receipt") && !action?.toLowerCase().includes('receipt generation');
    const isReceiptSuccess =
      isReceiptEntry && status.toLowerCase() === "completed";

    if (isReceiptEntry) {
      title = isReceiptSuccess ? `${action} - ${remark || ''}` : action;
      const courseId = log.courseId;

      if (!receiptCourseMap.has(courseId)) {
        receiptCourseMap.set(courseId, new Set());
      }

      const titleSet = receiptCourseMap.get(courseId);

      const lower = title.toLowerCase();
      const isNegative = lower.includes("negative");
      const isPositive = lower.includes("positive");

      const hasSameGroup =
        Array.from(titleSet).some((t) =>
          isNegative
            ? t.toLowerCase().startsWith("negative")
            : isPositive
              ? t.toLowerCase().startsWith("positive")
              : false
        );

      // Only add when not duplicate
      if (!hasSameGroup) {
        titleSet.add(title);

        // record the order here
        orderedUniqueTitles.push(title);
      }
    } else {
      title = log.event || action;
    }

    return {
      ...log,
      status: status.toLowerCase(),
      title,
    };
  });
  console.log('updatedLogList', updatedLogList, orderedUniqueTitles)
  return {
    updatedLogList,
    uniqueTitles: orderedUniqueTitles.reverse(),
  };
};

export const updateOtherReceiptEntryLogs = (logs = []) => {
  const receiptCourseMap = new Map();
  const orderedUniqueTitles = []; //  preserve insertion order

  const updatedLogList = logs.map((log) => {
    let title;
    const { action = "", status = "", remark = "", additionalInfo, courseId } = log;

    const isReceiptEntry = action?.toLowerCase().includes("receipt") && !action?.toLowerCase().includes('receipt generation');
    const isReceiptSuccess =
      isReceiptEntry && status?.toLowerCase() === "completed";

    if (isReceiptEntry) {
      title = isReceiptSuccess ? `${action} - ${remark}` : action;

      if (!receiptCourseMap.has(courseId)) {
        receiptCourseMap.set(courseId, new Set());
      }

      const logSet = receiptCourseMap.get(courseId);

      const isNegative = title.toLowerCase().includes("negative");
      const isPositive = title.toLowerCase().includes("positive");

      let existsSameType = Array.from(logSet).some(
        (t) =>
          t.additionalInfo === additionalInfo &&
          ((isNegative && t.title.toLowerCase().startsWith("negative")) ||
            (isPositive && t.title.toLowerCase().startsWith("positive")))
      );

      if (!existsSameType) {
        const entry = { title, additionalInfo };
        logSet.add(entry);

        //  Keep insertion order across whole log list
        orderedUniqueTitles.push(title);
      }
    } else {
      title = log?.event || action;
    }

    return {
      ...log,
      status: status?.toLowerCase(),
      title,
    };
  });

  return {
    updatedLogList,
    uniqueTitles: orderedUniqueTitles.reverse(),
  };
};



export const updateReceiptEntryLogs = (logs = [], orderType) => {
  if (orderType === 'RECTIFICATION_REFUND' || orderType === 'INTERNAL_REFUND') {
    return updateRectificationReceiptEntryLogs(logs);
  }
  // else if (orderType == 'COMPLETION_REFUND') {
  //   const updatedLogList = (logs || []).map((item => ({ ...item, title: item?.event, status: item?.status.toLowerCase() })))
  //   return {
  //     updatedLogList,
  //     uniqueTitles: [],
  //   }
  // }
  else {
    return updateOtherReceiptEntryLogs(logs);
  }
}

